import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import usePlayerSelector from '../utils/usePlayerSelector';
import { useCachedOktaQuery } from './useOktaQuery';
import { Game } from './data';

dayjs.extend(isSameOrAfter);

const queryPlayerGamesAndSeries = async (accessToken, teamId) => {
    if (!teamId || window.$IsDugoutApp) return { games: [], series: [] };
    // const games = await Game.upcoming(accessToken, { teamId, includePrevious: true });
    // let series = games.reduce((acc, g) => {
    //     const isHomeGame = g.HomeTeam.TeamID === teamId;
    //     const opposingTeam = isHomeGame ? g.AwayTeam : g.HomeTeam;
    //     const isNewSeries = acc.length === 0 || opposingTeam.TeamID !== acc[acc.length - 1].TeamID || acc[acc.length - 1].isHomeSeries !== isHomeGame;
    //     if (isNewSeries) {
    //         acc.push({
    //             ...opposingTeam,
    //             isHomeSeries: opposingTeam === g.AwayTeam,
    //             isCurrentSeries: dayjs().isSameOrAfter(g.GameDate, 'day'),
    //             startDate: g.GameDate,
    //             endDate: g.GameDate,
    //             games: [g],
    //         });
    //     } else {
    //         acc[acc.length - 1].endDate = g.GameDate;
    //         acc[acc.length - 1].games.push(g);
    //     }
    //     return acc;
    // }, []);
    const numSeries = (new Date()).getMonth() >= 9 ? 3 : 2;
    let series = await Game.upcomingSeries(accessToken, { teamId, includePrevious: true, numSeries });

    series = series.map((s, ix) => {
        const isPreviousSeries = dayjs().isAfter(s.endDate, 'day');
        const isCurrentSeries = !dayjs().isAfter(s.endDate, 'day') && ix === 0;
        return {
            ...s,
            ...s.Opponent,
            isHomeSeries: s.IsHome,
            isPreviousSeries,
            isCurrentSeries: isCurrentSeries && !isPreviousSeries,
            startDate: s.StartDate,
            endDate: s.EndDate,
            games: s.Games ?? [],
        };
    });

    return { games: series.flatMap((s) => s.Games), series };
};

const usePlayerGamesQuery = (queryProps) => {
    const { PlayerID, TeamID, ...player } = usePlayerSelector();
    const { data, isLoading } = useCachedOktaQuery(
        ['playerseries', TeamID],
        (accessToken) => queryPlayerGamesAndSeries(accessToken, TeamID),
        queryProps,
    );
    return { PlayerID, TeamID, isLoading, ...player, ...data };
};

export default usePlayerGamesQuery;
